import { DomainUpsertLoadingList } from "@/components/domain";
import { useSyncLoading } from "@/context/sheet";
import { useGetGuide, useUpdateGuide } from "@/hooks/guides";
import { CreateGuide, Guide } from "@/models";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Form } from "./-form";

export const Route = createFileRoute("/(guides)/guides/_sheet/$id/edit")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();

  const { isLoading, data: model } = useGetGuide(id);
  useSyncLoading(isLoading);

  if (isLoading || !model) return <DomainUpsertLoadingList />;
  return <Edit model={model} />;
}

function Edit({ model }: { model: Guide }) {
  const navigate = useNavigate();
  const { mutateAsync } = useUpdateGuide({
    onSuccess: (guide) => {
      navigate({
        to: "/guides",
        params: { id: guide.id.toString() },
      });
    },
  });

  const update = async (guide: CreateGuide) => {
    await mutateAsync({ id: model.id, ...guide });
  };
  return <Form model={model} onUpsert={update} />;
}
